import { useEffect, useRef } from "react"

export default function AbrirApp() {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    let timeoutId;

    if (iframeRef.current) {
      iframeRef.current.src = "focoapp://";

      timeoutId = setTimeout(() => {
        let link = "https://play.google.com/store/apps/details?id=foco.APP";
        
        const userAgent = navigator.userAgent || '';
        if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
          link = 'https://apps.apple.com/br/app/foco-aluguel-de-carros/id1622202895';
        }

        window.location.href = link;
      }, 500);
    }
  }, []);

  return (
    <iframe width="1" height="1" style={{ visibility: 'hidden' }} ref={iframeRef} />
  )
}